import '@magnetic/theme';
import './style.css.js';
import { Button } from '@magnetic/button';
import { Flex } from '@magnetic/flex';
import { withSubComponent } from '@magnetic/higher-order-components';
import { useClassNames, useBoolean } from '@magnetic/hooks';
import { Status, CopySimple } from '@magnetic/icons';
import { Popover } from '@magnetic/popover';
import { Tooltip } from '@magnetic/tooltip';
import React, { forwardRef, useCallback } from 'react';
import { IconOnly } from './icon-only.js';

const CopyToClipboard = withSubComponent(
  forwardRef(
    ({
      className,
      contained,
      copyText = "Copy",
      label,
      size = "md",
      value,
      ...rest
    }, ref) => {
      const classNames = useClassNames(
        "mds-copy-to-clipboard",
        `mds-copy-to-clipboard-size-${size}`,
        {
          "mds-copy-to-clipboard-contained": contained
        },
        className
      );
      const {
        setFalse: setShowTooltipFalse,
        setTrue: setShowTooltipTrue,
        value: showTooltip
      } = useBoolean(true);
      const onClick = useCallback(() => {
        navigator.clipboard.writeText(value);
        setShowTooltipFalse();
      }, [value, setShowTooltipFalse]);
      const setOpen = useCallback(() => {
        setShowTooltipTrue();
      }, [setShowTooltipTrue]);
      return /* @__PURE__ */ React.createElement("div", { className: classNames, ref, ...rest }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement("div", null, value, /* @__PURE__ */ React.createElement(
        Popover,
        {
          open: !showTooltip,
          setOpen,
          title: /* @__PURE__ */ React.createElement(Flex, { align: "center", gap: 4 }, /* @__PURE__ */ React.createElement(Status, { status: "good" }), "Copied to clipboard")
        },
        /* @__PURE__ */ React.createElement(Tooltip, { disabled: !showTooltip, title: "Copy to clipboard" }, /* @__PURE__ */ React.createElement(
          Button,
          {
            "aria-label": `${copyText}: ${value}`,
            icon: /* @__PURE__ */ React.createElement(CopySimple, null),
            id: "button",
            kind: "tertiary",
            onClick
          },
          copyText
        ))
      )));
    }
  ),
  { IconOnly }
);

export { CopyToClipboard };
//# sourceMappingURL=index.js.map
